import React from 'react';
import PropTypes from 'prop-types';

const FilesForYearExistsColumnFormatter = (filesExists, intl) => {

  const getValue = filesExists => {
    if (filesExists === null) {
      return '';
    } else {
      return filesExists
        ? intl.formatMessage({
          id: 'complete-details-column-form101Year-exists',
          defaultMessage: 'yes'
        })
        : intl.formatMessage({
          id: 'complete-details-column-form101Year-doesntExists',
          defaultMessage: 'no'
        });
    }
  };

  return (
    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
      {getValue(filesExists)}
    </span>
  );
};

FilesForYearExistsColumnFormatter.propTypes = {
  filesExists: PropTypes.bool
};

export {FilesForYearExistsColumnFormatter};
